import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "notice-list mb-3"
}
const _hoisted_3 = { class: "notice-card-icon" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-xl-12 col-lg-6 col-xxxl-6 col-md-6" }
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white monthly-revenue-box" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_10 = { class: "fw-black mb-12 lh-1" }
const _hoisted_11 = { class: "col-xl-12 col-lg-6 col-xxxl-6 col-md-6" }
const _hoisted_12 = { class: "card mb-25 border-0 rounded-0 bg-white monthly-new-customers-box" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "fw-black mb-12 lh-1" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "card mb-25 border-0 rounded-0 letter-spacing courses-list-box" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "title position-relative mb-12 mb-md-12" }
const _hoisted_22 = { class: "mb-0 text-black fw-bold" }
const _hoisted_23 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_24 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_25 = { class: "fw-bold text-primary" }
const _hoisted_26 = { class: "fw-bold text-primary" }
const _hoisted_27 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_28 = { class: "fw-bold text-primary" }
const _hoisted_29 = { class: "fw-bold text-primary" }
const _hoisted_30 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_31 = { class: "fw-bold text-primary" }
const _hoisted_32 = { class: "fw-bold text-primary" }
const _hoisted_33 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_34 = { class: "fw-bold text-primary" }
const _hoisted_35 = { class: "col-lg-6" }
const _hoisted_36 = { class: "card mb-25 border-0 rounded-0 letter-spacing courses-list-box" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = { class: "title position-relative mb-12 mb-md-12" }
const _hoisted_39 = { class: "mb-0 text-black fw-bold" }
const _hoisted_40 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_41 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_42 = { class: "fw-bold text-warning" }
const _hoisted_43 = { class: "fw-bold text-warning" }
const _hoisted_44 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_45 = { class: "fw-bold text-warning" }
const _hoisted_46 = { class: "fw-bold text-warning" }
const _hoisted_47 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_48 = { class: "fw-bold text-warning" }
const _hoisted_49 = { class: "fw-bold text-warning" }
const _hoisted_50 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_51 = { class: "fw-bold text-warning" }
const _hoisted_52 = { class: "col-lg-6" }
const _hoisted_53 = { class: "card mb-25 border-0 rounded-0 letter-spacing courses-list-box" }
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "title position-relative mb-12 mb-md-12" }
const _hoisted_56 = { class: "mb-0 text-black fw-bold" }
const _hoisted_57 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_58 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_59 = { class: "fw-bold text-danger" }
const _hoisted_60 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_61 = { class: "fw-bold text-danger" }
const _hoisted_62 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_63 = { class: "fw-bold text-danger" }
const _hoisted_64 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_65 = { class: "fw-bold text-danger" }
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = { class: "card mb-25 border-0 rounded-0 letter-spacing courses-list-box" }
const _hoisted_68 = { class: "card-body" }
const _hoisted_69 = { class: "title position-relative mb-12 mb-md-12" }
const _hoisted_70 = { class: "mb-0 text-black fw-bold" }
const _hoisted_71 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_72 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_73 = { class: "fw-bold text-success" }
const _hoisted_74 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_75 = { class: "fw-bold text-success" }
const _hoisted_76 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_77 = { class: "fw-bold text-success" }
const _hoisted_78 = { class: "d-inline-block bg-white fs-13 text-muted fw-medium" }
const _hoisted_79 = { class: "fw-bold text-success" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-lg-6" }
const _hoisted_82 = { class: "col-lg-6" }
const _hoisted_83 = {
  key: 0,
  class: "col-lg-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatsBoxes = _resolveComponent("StatsBoxes")!
  const _component_ChartCitieStatistics = _resolveComponent("ChartCitieStatistics")!
  const _component_DonutStatusChart = _resolveComponent("DonutStatusChart")!
  const _component_TopProductStock = _resolveComponent("TopProductStock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.visibleAds.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_TransitionGroup, {
              name: "notice-fade",
              tag: "div"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleAds, (ads) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ads.id ?? ads.ads_text,
                    class: _normalizeClass(['notice-card', `notice-card-${ads.ads_type}`]),
                    role: "alert"
                  }, [
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.adsIcon(ads.ads_type))
                      }, null, 2)
                    ]),
                    _createElementVNode("div", {
                      class: "notice-card-body",
                      innerHTML: ads.ads_text
                    }, null, 8, _hoisted_4),
                    _createElementVNode("button", {
                      type: "button",
                      class: "notice-card-close",
                      "aria-label": "Close",
                      onClick: ($event: any) => (_ctx.dismissAd(ads))
                    }, _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "flaticon-close" }, null, -1)
                    ]), 8, _hoisted_5)
                  ], 2))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, [
              _createTextVNode(" REVENUE NET "),
              _createElementVNode("small", null, "(DH)")
            ], -1)),
            _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.dashData?.NetRevenue || 0), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " TOTAL COLIS ", -1)),
              _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.dashData?.Parcels?.totalparcels || 0), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_StatsBoxes, { dashData: _ctx.dashData }, null, 8, ["dashData"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon text-center rounded-circle position-relative bg-primary" }, [
                _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-white" }, [
                  _createElementVNode("i", {
                    class: "flaticon-sterile-box",
                    style: {"display":"flex","justify-content":"center","align-items":"center","width":"64px","height":"60px","font-size":"32px"}
                  })
                ])
              ], -1)),
              _createElementVNode("h6", _hoisted_22, [
                _cache[3] || (_cache[3] = _createTextVNode(" Colis Livrés ", -1)),
                _createElementVNode("b", null, " (" + _toDisplayString(_ctx.sum(
                    _ctx.dashData?.Parcels?.deliveredparcelsinvoiced,
                    _ctx.dashData?.Parcels?.deliveredparcelsnotinvoiced
                  )) + ")", 1)
              ])
            ]),
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.dashData?.Parcels?.deliveredparcelsinvoiced), 1),
                _cache[5] || (_cache[5] = _createTextVNode(" Colis Facturé ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.dashData?.Parcels?.deliveredparcelsnotinvoiced), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" Colis Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtdelivredinvoiced), 1),
                _cache[8] || (_cache[8] = _createTextVNode(" Crbt Facturé ", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtdelivrednotinvoiced), 1),
                _cache[10] || (_cache[10] = _createTextVNode(" Crbt Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesdelivredinvoiced), 1),
                _cache[11] || (_cache[11] = _createTextVNode(" Frais Facturé ", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesdelivrednotinvoiced), 1),
                _cache[13] || (_cache[13] = _createTextVNode(" Frais Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.dashData?.Parcels?.totalofalldelivered), 1)
                ]),
                _cache[14] || (_cache[14] = _createTextVNode(" Total ", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "icon text-center rounded-circle position-relative bg-warning" }, [
                _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-white" }, [
                  _createElementVNode("i", {
                    class: "flaticon-sterile-box",
                    style: {"display":"flex","justify-content":"center","align-items":"center","width":"64px","height":"60px","font-size":"32px"}
                  })
                ])
              ], -1)),
              _createElementVNode("h6", _hoisted_39, [
                _cache[15] || (_cache[15] = _createTextVNode(" Colis Refusés ", -1)),
                _createElementVNode("b", null, " (" + _toDisplayString(_ctx.sum(
                    _ctx.dashData?.Parcels?.refuseparcelsinvoiced,
                    _ctx.dashData?.Parcels?.refuseparcelsnotinvoiced
                  )) + ")", 1)
              ])
            ]),
            _createElementVNode("ul", _hoisted_40, [
              _createElementVNode("li", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.dashData?.Parcels?.refuseparcelsinvoiced), 1),
                _cache[17] || (_cache[17] = _createTextVNode(" Colis Facturé ", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.dashData?.Parcels?.refuseparcelsnotinvoiced), 1),
                _cache[19] || (_cache[19] = _createTextVNode(" Colis Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_44, [
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtrefuseinvoiced), 1),
                _cache[20] || (_cache[20] = _createTextVNode(" Crbt Facturé ", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtrefusednotinvoiced), 1),
                _cache[22] || (_cache[22] = _createTextVNode(" Crbt Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_47, [
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesrefuseinvoiced), 1),
                _cache[23] || (_cache[23] = _createTextVNode(" Frais Facturé ", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesrefusenotinvoiced), 1),
                _cache[25] || (_cache[25] = _createTextVNode(" Frais Non Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.dashData?.Parcels?.totalofallrefuse), 1)
                ]),
                _cache[26] || (_cache[26] = _createTextVNode(" Total ", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "icon text-center rounded-circle position-relative bg-danger" }, [
                _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-white" }, [
                  _createElementVNode("i", {
                    class: "flaticon-sterile-box",
                    style: {"display":"flex","justify-content":"center","align-items":"center","width":"64px","height":"60px","font-size":"32px"}
                  })
                ])
              ], -1)),
              _createElementVNode("h6", _hoisted_56, [
                _cache[27] || (_cache[27] = _createTextVNode(" Colis Retournés ", -1)),
                _createElementVNode("b", null, " (" + _toDisplayString(_ctx.dashData?.Parcels?.returnedparcels) + ")", 1)
              ])
            ]),
            _createElementVNode("ul", _hoisted_57, [
              _createElementVNode("li", _hoisted_58, [
                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.dashData?.Parcels?.returnedparcels), 1),
                _cache[29] || (_cache[29] = _createTextVNode(" Colis Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_60, [
                _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtreturned), 1),
                _cache[30] || (_cache[30] = _createTextVNode(" Crbt Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesretunred), 1),
                _cache[31] || (_cache[31] = _createTextVNode(" Frais Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_64, [
                _createElementVNode("span", _hoisted_65, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.dashData?.Parcels?.totalofallretunred), 1)
                ]),
                _cache[32] || (_cache[32] = _createTextVNode(" Total ", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "icon text-center rounded-circle position-relative bg-success" }, [
                _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-white" }, [
                  _createElementVNode("i", {
                    class: "flaticon-sterile-box",
                    style: {"display":"flex","justify-content":"center","align-items":"center","width":"64px","height":"60px","font-size":"32px"}
                  })
                ])
              ], -1)),
              _createElementVNode("h6", _hoisted_70, [
                _cache[33] || (_cache[33] = _createTextVNode(" Colis En Cours ", -1)),
                _createElementVNode("b", null, " (" + _toDisplayString(_ctx.dashData?.Parcels?.inprogressparcels) + ")", 1)
              ])
            ]),
            _createElementVNode("ul", _hoisted_71, [
              _createElementVNode("li", _hoisted_72, [
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.dashData?.Parcels?.inprogressparcels), 1),
                _cache[35] || (_cache[35] = _createTextVNode(" Colis Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_74, [
                _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.dashData?.Parcels?.totalcrbtinprogress), 1),
                _cache[36] || (_cache[36] = _createTextVNode(" Crbt Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_76, [
                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.dashData?.Parcels?.totalfeesinprogress), 1),
                _cache[37] || (_cache[37] = _createTextVNode(" Frais Facturé ", -1))
              ]),
              _createElementVNode("li", _hoisted_78, [
                _createElementVNode("span", _hoisted_79, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.dashData?.Parcels?.totalofallinProgress), 1)
                ]),
                _cache[38] || (_cache[38] = _createTextVNode(" Total ", -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createVNode(_component_ChartCitieStatistics)
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createVNode(_component_DonutStatusChart)
      ]),
      (_ctx.perms.stock === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
            _createVNode(_component_TopProductStock)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}